import axiosInstance from './api_helper';

export const searchFinancialDocuments = async (params) =>
  axiosInstance.get('/api/finance/document-payment-history/search', { params });

export const getDocumentPaymentHistory = async (params) =>
  axiosInstance.get('/api/finance/document-payment-history', { params });
